import * as Component from './scripts/core/Component'
import { Map } from './components/main/map/index'
import { Dialog } from './components/ui/dialog/index'
import { FeedbackForm } from './components/main/feedbackForm/index'
import { Page } from './components/main/page/index'
import { HeaderButton } from './components/main/header/headerButton/index'
import { Navigation } from './components/main/navigation/index'
import { Slider } from './components/ui/slider/index'
import { LocalStorageProxy } from './scripts/utils/storage'

let page = new Page();
let storage = new LocalStorageProxy()

Component.Block.list(Map)
Component.Block.list(Navigation)
Component.Block.list(Slider)
let feedbackFormList = Component.Block.list(FeedbackForm)

linkFeedbackDialog()
linkFormSucessDialog()
linkFormFailuresDialog()

function linkFeedbackDialog() {
  try {
    let dialog = new Dialog(document.querySelector('.dialog--feedback'))

    let dialogTimerId = 0
    
    if(!storage.get('is_popup_closed')) {
      dialogTimerId = setTimeout(() => {
        dialog.open()
      }, 30 * 1000)
    }

    dialog.onOpen(() => {
      page.disableScroll()
    })

    dialog.onClose(() => {
      page.enableScroll()
      dialog.resetInnerForms()
      storage.set('is_popup_closed', 'true')
    })

    let feedbackButton = new HeaderButton(document.querySelector('.headerButton--feedback'))

    feedbackButton.el.addEventListener('click', function (e) {
      e.preventDefault()
      clearTimeout(dialogTimerId)
      dialog.open()
    })

    feedbackFormList.forEach(
      (form) => {
        form.onSuccess(() => {
          clearTimeout(dialogTimerId)
          dialog.close()
        })
      }
    )

  } catch (e) {
    console.error(e)
  }
}

function linkFormSucessDialog() {
  try {
    let dialogSuccess = new Dialog(document.querySelector('.dialog--success'))

    dialogSuccess.onOpen(() => {
      page.disableScroll()
    })

    dialogSuccess.onClose(() => {
      page.enableScroll()
    })

    feedbackFormList.forEach(
      (form) => {
        form.onSuccess(() => {
          dialogSuccess.open()
        })
        form.onFailure(() => {
          dialogSuccess.close()
        })
      }
    )

  } catch (e) {
    console.error(e)
  }
}



function linkFormFailuresDialog() {
  try {
    let dialogFailure = new Dialog(document.querySelector('.dialog--failure'))

    dialogFailure.onOpen(() => {
      page.disableScroll()
    })

    dialogFailure.onClose(() => {
      page.enableScroll()
    })

    feedbackFormList.forEach(
      (form) => form.onFailure(() => {
        dialogFailure.open()
      })
    )

  } catch (e) {
    console.error(e)
  }
}







// WEBPACK FOOTER //
// ./index.js